import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/eu-readiness-pharma")({
  head: () => buildRouteHead("/eu-readiness-pharma", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/eu-readiness-pharma", replace: true });
  },
});
